import React from "react";
import { any, array } from "prop-types";

const propTypes = {
  children: any,
  headers: array.isRequired,
};

const Table = (props) => {
  return (
    <table className="table" id="content-wrapper">
      <thead>
        <tr>{props.headers}</tr>
      </thead>
      <tbody>{props.children}</tbody>
    </table>
  );
};

Table.propTypes = propTypes;
export default Table;
